import { TextInput, Text, PasswordInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconLogin } from "@tabler/icons";
import { MyButton } from "../../UI/my-button/MyButton";
import { useColors } from "../../../hooks/colors/useColors";
import { Fragment, useState } from "react";
import { useFirebaseAuth } from "../../../hooks/firebase/useFirebaseAuth";
import { useRouter } from "next/router";
import {
  queryClient,
  QueryKeys,
} from "../../../hooks/react-query/query-client";
import { useTranslation } from "next-i18next";
import { ForgotPassword } from "./ForgotPassword";

export function LoginForm(props: { closeModal?: () => void }) {
  const { colors } = useColors();
  const { logInWithEmailAndPassword, returnError } = useFirebaseAuth();
  const [error, setError] = useState<string>("");
  const [processing, setProcessing] = useState<boolean>(false);
  const router = useRouter();
  const { t } = useTranslation("common");
  const [openRecoveryForm, setOpenRecoveryForm] = useState<boolean>(false);
  const form = useForm({
    initialValues: {
      email: "",
      password: "",
    },
    validate: {
      email: (value) =>
        /^\S+@\S+$/.test(value) ? null : t("login.invalidEmail"),
    },
  });

  async function login(form: { email: string; password: string }) {
    setProcessing(true);
    setError("");
    try {
      const serverResponse = await logInWithEmailAndPassword(
        form.email,
        form.password
      );

      if (typeof serverResponse === "string") {
        setError(returnError(serverResponse));
        setProcessing(false);
      } else {
        setProcessing(false);
        if (props.closeModal) {
          props.closeModal();
        }
        await queryClient.invalidateQueries(QueryKeys.JWT);
        await queryClient.invalidateQueries(QueryKeys.USER);
        await queryClient.invalidateQueries(QueryKeys.PAST_APPOINTMENTS);
        await queryClient.invalidateQueries(QueryKeys.APPOINTMENTS);
        await queryClient.invalidateQueries(QueryKeys.NOTIFICATIONS);
        await queryClient.invalidateQueries(QueryKeys.ATTACHMENTS);
        if (props.closeModal) {
          await router.push("/user");
        }
      }
    } catch (err) {
      console.error(err);
      // @ts-ignore
      setError(returnError(err.toString()));
      setProcessing(false);
    }
  }

  return (
    <Fragment>
      {!openRecoveryForm && (
        <form onSubmit={form.onSubmit((values) => login(values))}>
          <TextInput
            error={form.errors.email}
            withAsterisk
            className="mb-4"
            type="text"
            label="Email"
            placeholder="your@email.com"
            {...form.getInputProps("email")}
          />
          <PasswordInput
            withAsterisk
            label="Password"
            {...form.getInputProps("password")}
          />
          {error.length > 1 && <Text color={colors.danger}>{error}</Text>}
          <a href="#" onClick={() => setOpenRecoveryForm(true)}>
            <Text color="blue" className="mt-2 hover:opacity-90">
              <span className="active:opacity-70">{t("login.forgot")}</span>
            </Text>
          </a>
          <MyButton
            fullWidth
            disabled={processing}
            loading={processing}
            icon={<IconLogin />}
            submit
            className="w-full mt-8"
            title={t("login.login")}
            textColor="white"
            color={colors.primary}
            onClick={() => {}}
          />
        </form>
      )}
      {openRecoveryForm && <ForgotPassword />}
    </Fragment>
  );
}
